
<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content class="mat-typography">
  <h3 [style]="data.style" [innerHTML]="data.msg"></h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-raised-button
    [mat-dialog-close]="true"
    cdkFocusInitial
    color="warn"
  >
    {{ data.confirmText }}
  </button>
  <button mat-raised-button color="primary" mat-dialog-close>{{ data.cancelText }}</button>
</mat-dialog-actions>
